import { useEffect, useRef, useState } from "react";

// Simulated (not byte-level) progress bar shown while a quick create/add API call is
// in flight - gives clearer visual feedback than a disabled "Adding..." button alone.
// Eases toward 90% while `active` is true, snaps to 100% the instant it finishes, then
// fades out shortly after.
export const AddingProgressBar = ({ active, label = "Adding…", testId = "adding-progress-bar" }) => {
  const [percent, setPercent] = useState(0);
  const [visible, setVisible] = useState(false);
  const intervalRef = useRef(null);
  const hideTimerRef = useRef(null);

  useEffect(() => {
    if (active) {
      clearTimeout(hideTimerRef.current);
      setVisible(true);
      setPercent(8);
      intervalRef.current = setInterval(() => {
        setPercent((p) => (p >= 90 ? p : p + (90 - p) * 0.18 + 1));
      }, 120);
    } else {
      clearInterval(intervalRef.current);
      setPercent((p) => (p > 0 ? 100 : 0));
      hideTimerRef.current = setTimeout(() => {
        setVisible(false);
        setPercent(0);
      }, 500);
    }
    return () => clearInterval(intervalRef.current);
  }, [active]);

  if (!visible) return null;

  return (
    <div className="mt-3 w-full" data-testid={testId}>
      <div className="flex items-center justify-between text-[11px] font-bold text-slate-500 dark:text-slate-400">
        <span>{label}</span>
        <span data-testid={`${testId}-percent`}>{Math.round(percent)}%</span>
      </div>
      <div className="mt-1.5 h-2 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-white/10">
        <div
          className="h-full rounded-full bg-[#0052FF] transition-[width] duration-150 ease-out"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
};
